import React, { useEffect, useRef, useState, useMemo } from 'react';
import styles from './AdViseStep6.module.css';
import api from '../../../api';
import axios from 'axios'
import { isBrowser, isIOS } from 'react-device-detect';
import { copyToClipboard, josa } from '../../../util';

const AdViseStep6 = ({ setAdViseStep, stepProps, setStepProps, marginTop }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOfficialLoading, setIsOfficialLoading] = useState(false);
  const [isPatching, setIsPatching] = useState(false);
  const [showSelectedOverlay, setShowSelectedOverlay] = useState(false);
  const [isGifMode, setIsGifMode] = useState(false);
  const [showThumbnailModal, setShowThumbnailModal] = useState(false);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [filterCursor1, setFilterCursor1] = useState(null);
  const [filterCursor2, setFilterCursor2] = useState(null);
  const [showPriorityModal, setShowPriorityModal] = useState(false);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showResourceModal, setShowResourceModal] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState([]);
  const [fileInfoList, setFileInfoList] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [resources, setResources] = useState([]);
  const [usedResource, setUsedResource] = useState([]);

  const lowerFrameRef = useRef(null);
  const controllerRef = useRef(null);
  const isFirstLoadRef = useRef(true);

  let selectedAvailableUrls = extractOfficialImageUrls(stepProps[4].place).filter((url, idx) => stepProps[6].selectedOfficialImages?.includes(idx))
    .concat(
      stepProps[6].selectedImages.filter(([b,i]) => stepProps[10]?.resourceStatus?.approve?.includes(stepProps[4].blogReviews[b].authorName))
      ?.map(([b, i]) => stepProps[4].blogImageUrls[b][i])
    );
  let selectedAvailableImages = stepProps[6].officialImages.filter((url, idx) => stepProps[6].selectedOfficialImages?.includes(idx))
    .concat(
      stepProps[6].selectedImages.filter(([b,i]) => stepProps[10]?.resourceStatus?.approve?.includes(stepProps[4].blogReviews[b].authorName))
      ?.map(([b, i]) => stepProps[6]?.blogImages?.[b]?.[i] ?? stepProps[6].gifImages?.[`${b}-${i}`] ?? null)
    );

  let selectedUrls = extractOfficialImageUrls(stepProps[4].place).filter((url, idx) => stepProps[6].selectedOfficialImages?.includes(idx)).concat(stepProps[6].selectedImages.map(([b, i]) => stepProps[4].blogImageUrls[b][i]));
  const selectedLength = selectedUrls.length;

  // GIF 엔트리 목록 계산
  const gifEntries = useMemo(() => {
    const list = [];
    (stepProps[4]?.blogImageUrls || []).forEach((urls, blogCursor) => {
      if(!stepProps[4].blogReviews[blogCursor].url.includes('blog.naver'))
        return;
      urls.forEach((url, imageIndex) => {
        if (url.toLowerCase().endsWith('.gif')) {
          list.push({ blogCursor, imageIndex, url });
        }
      });
    });
    return list;
  }, [stepProps[4]?.blogImageUrls]);

  useEffect(() => {
    const urls = extractOfficialImageUrls(stepProps[4].place);
    if (urls.length === 0 || (urls.length === stepProps[6].officialImages.length && !stepProps[6].officialImages.includes(undefined))) return;

    setIsOfficialLoading(true);
    axios.post('https://hotple.today/win-api/api/blog-image', {
      image_urls: urls,
      need_compress: true
    }).then(res => {
      const images = Array.isArray(res.data.images)
        ? res.data.images
        : [];

      setStepProps(prev => {
        const newProps = [...prev];
        newProps[6] = {
          ...newProps[6],
          officialImages: images,
        };
        return newProps;
      });
    }).catch(err => {
      console.error('공식 이미지 로드 실패:', err);
    }).finally(()=>{
      setIsOfficialLoading(false);
    });
  }, [stepProps[4].place])

  function extractOfficialImageUrls(place) {
      const origins = [];
      if (!place || typeof place !== 'object') return origins;

      const root = place.ROOT_QUERY;
      if (!root || typeof root !== 'object') return origins;

      // 1) placeDetail(...) 객체 찾기
      const detailEntry = Object.entries(root)
      .find(([key, val]) =>
          key.startsWith("placeDetail") &&
          val && typeof val === "object"
      );
      if (!detailEntry) return origins;
      const detailObj = detailEntry[1];

      // 2) images(...) 객체 찾기
      const imagesEntry = Object.entries(detailObj)
      .find(([key, val]) =>
          key.startsWith("images") &&
          val &&
          Array.isArray(val.images)
      );
      if (!imagesEntry) return origins;
      const imagesArr = imagesEntry[1].images;

      // 3) origin 필드만 수집
      for (const imgObj of imagesArr) {
        if (imgObj && typeof imgObj.origin === "string") {
            origins.push(imgObj.origin);
        }
      }

      return origins;
  }

  function whenSaveButtonClicked() {
    if (selectedLength < 9)
      return;

    setShowSaveModal(true);
  }

  // 블로그 이미지 요청
  const getBlogImages = async (blogCursor, image_urls, signal) => {
    const placeId = stepProps[3].hotple.naver_map_place_id;
    const isNaverBlog =
      stepProps[4].blogReviews[blogCursor].url.includes('blog.naver');
    const shouldSkip = !isNaverBlog || !Array.isArray(image_urls) || image_urls.length === 0;

    if (shouldSkip) {
      // URL 없거나 블로그가 네이버가 아니면 빈 배열로 덮어쓰기
      setStepProps(prev => {
        const newProps = [...prev];
        const prevImgs = newProps[6]?.blogImages || [];
        const updatedImgs = [...prevImgs];
        updatedImgs[blogCursor] = [];
        newProps[6] = {
          ...newProps[6],
          blogImages: updatedImgs,
          placeId
        };
        return newProps;
      });
      return;
    }

    try {
      const response = await axios.post(
        'https://hotple.today/win-api/api/blog-image',
        { image_urls, need_compress: true },
        { signal }
      );
      const fetched = Array.isArray(response.data.images)
        ? response.data.images
        : [];

      // 정상 응답 시 해당 인덱스에 덮어쓰기
      setStepProps(prev => {
        const newProps = [...prev];
        const prevImgs = newProps[6]?.blogImages || [];
        const updatedImgs = [...prevImgs];
        updatedImgs[blogCursor] = fetched;
        newProps[6] = {
          ...newProps[6],
          blogImages: updatedImgs,
          placeId
        };
        return newProps;
      });
    } catch (error) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') {
        console.log('요청이 취소되었습니다.');
      } else {
        console.error('Error getBlogImages:', error);
      }
    }
  };

  // 블로그 포스트 디테일 + 이미지 로드
  const loadBlogImages = async (blogCursor) => {
    if (isLoading) return;
    setIsLoading(true);

    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    if (stepProps[6].blogCursor >= Math.min(stepProps[4].blogImageUrls.length, stepProps[4].blogReviews.length)) {
      // 새로 로드
      const result = await getBlogPostDetail(stepProps[4].blogReviews[blogCursor].url, signal);
      const { text, imageUrls } = result;
      setStepProps(prev => {
        const newProps = [...prev];
        newProps[4] = {
          ...newProps[4],
          blogImageUrls: [...newProps[4].blogImageUrls, imageUrls],
          blogTexts: [...newProps[4].blogTexts, text]
        };
        return newProps;
      });
      await getBlogImages(blogCursor, imageUrls, signal);
    } else {
      // 이미 URL 목록이 있으면 바로 이미지 다운로드
      await getBlogImages(blogCursor, stepProps[4].blogImageUrls[blogCursor], signal);
    }

    setIsLoading(false);
    setStepProps(prev => {
      const newProps = [...prev];
      newProps[6] = {
        ...newProps[6],
        blogCursor: blogCursor + 1
      };
      return newProps;
    });
  };

  // 블로그 내용 + 이미지 URL 추출
  const getBlogPostDetail = async (url, signal) => {
    try {
      const response = await axios.get('https://hotple.today/win-api/api/blog-post-detail', {
        params: { url },
        signal
      });
      return {
        text: response.data.text,
        imageUrls: response.data.can_reply ? (response.data.imageUrls || []) : []
      };
    } catch {
      return {
          text: null,
          imageUrls: []
      }
    }
  };

  const whenSourceClicked = (url) => window.open(url, '_blank');
  const whenHomeButtonClicked = () => {
    if (window.confirm("선택한 정보들이 모두 초기화돼요.\n\n정말 첫 화면으로 돌아갈까요?")) {
      setAdViseStep(0);
    }
  };

  const whenImageClicked = (blogCursor, imageIndex) => {
    const prev = stepProps[6].selectedImages || [];
    const exists = prev.some(([b, i]) => b === blogCursor && i === imageIndex);
    const newSelected = exists
      ? prev.filter(([b, i]) => !(b === blogCursor && i === imageIndex))
      : [...prev, [blogCursor, imageIndex]];
    setStepProps(prev => {
      const next = [...prev];
      next[6] = { ...next[6], selectedImages: newSelected };
      return next;
    });
    if (newSelected.length === 0 && (stepProps[6].selectedOfficialImages?.length ?? 0) === 0) {
      setShowSelectedOverlay(false);
    }
  };

  const whenOfficialImageClicked = (idx) => {
    const prev = stepProps[6].selectedOfficialImages || [];
    const exists = prev.some((index) => index == idx);
    const newSelected = exists
      ? prev.filter((index) => !(index == idx))
      : [...prev, idx];
    setStepProps(prev => {
      const next = [...prev];
      next[6] = { ...next[6], selectedOfficialImages: newSelected };
      return next;
    });
    if (stepProps[6].selectedImages.length ===0 && newSelected.length === 0) {
      setShowSelectedOverlay(false);
    }
  };

  const whenNextButtonClicked = async () => {
    if (selectedLength < 9) return;
    
    setIsPatching(true);

    try {
      const res = await axios.post(
        'https://hotple.today/win-api/api/blog-image',
        {
          image_urls: selectedAvailableUrls,
          need_compress: false
        }
      );
      setStepProps(prev => {
        const next = [...prev];
        next[7] = { ...next[7], originalImages: res.data.images };
        return next;
      });
      setAdViseStep(7);
    } catch (err) {
      console.error('원본 이미지 로드 오류:', err);
      alert('원본 이미지를 불러오는 중 오류가 발생했습니다.');
    } finally {
      setIsPatching(false);
    }
  };

  const whenResetButtonClicked = () => {
    if (window.confirm('선택한 이미지들을 초기화하고, 처음부터 다시 선택할까요?')) {
      setStepProps(prev => {
        const next = [...prev];
        next[6] = { ...next[6], selectedImages: [], selectedOfficialImages: []};
        return next;
      });
      lowerFrameRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const whenTopButtonClicked = () => {
    lowerFrameRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const whenNameChanged = (value) => {
    setStepProps(prev => {
      const newProps = [...prev];
      newProps[8] = {...newProps[8], fileName: value}
      return newProps;
    })
  }

  async function loadResources() {
    try {
      const resp = await api.get('/advise/admin/fileInfo', {
        params: { name: stepProps[8].fileName }
      });
      // resp.data 가 [ { name, …, resources }, … ] 형태로 오니까
      const matched = Array.isArray(resp.data)
        ? resp.data.find(f => f.name === stepProps[8].fileName)
        : resp.data;
      setResources(matched?.resources || []);
      setUsedResource(matched?.used_resource||[]);
    } catch (err) {
      console.error('리소스 정보 가져오기 실패:', err);
    }
  }

  const handleResourceStatusChange = async (authorName, newStatus) => {
    const resourceIds = [];

    resources.forEach(res => {
      if(res.author_name==authorName)
        resourceIds.push(res.id);
    });

    resourceIds.forEach(resId => {
      patchResourceStatusChange(resId, newStatus);
    });
  }

  const patchResourceStatusChange = async (resourceId, newStatus) => {
    try {
      const { data: updated } = await api.patch(
        `/advise/admin/resource/${resourceId}/status`,
        { status: newStatus }
      );
      setResources(rs => {
       const updatedResources = rs.map(r =>
         r.id === resourceId ? { ...r, status: updated.status } : r
       );

       // 2) resourceStatus 맵 재계산
       const statusMap = {
         '승인 필요': 'before',
         '승인 대기': 'pending',
         '승인 완료': 'approve',
         '승인 거절': 'denied',
       };
       const resourceStatus = updatedResources.reduce((acc, r) => {
         const key = statusMap[r.status];
         if (key) acc[key].push(r.author_name);
         return acc;
       }, { before: [], pending: [], approve: [], denied: [] });

       // 3) stepProps[10].resourceStatus 업데이트
       setStepProps(prev => {
         const next = [...prev];
         next[10] = {
           ...next[10],
           resourceStatus
         };
         return next;
       });

       return updatedResources;
     });
    } catch (err) {
      console.error('리소스 상태 변경 실패:', err);
      alert('상태 변경에 실패했습니다.');
    }
  };

  const whenBlogClicked = (status, url, authorName) => {
    const comment = `안녕하세요 ${authorName}님😊 저는 지역별 핫플레이스를 매일 한 장소씩 소개해주는 HOTPLE 인스타/페북 운영자입니다!

이번에 저희 팔로워 분들께 [${stepProps[3].hotple.name}]${josa(stepProps[3].hotple.name,'을를')} 소개드리구 싶어서 찾아보던 중에 예쁘게 잘 찍어주신 사진이 눈에 띄더라구요ㅎㅎ

혹시 ${stepProps[3].hotple.name}${josa(stepProps[3].hotple.name,'을를')} 소개할 때 ${authorName}님께서 찍어주신 사진을 함께 보여드려도 괜찮을지 여쭤봐도 될까요? (물론, 출처도 이미지 위에 꼭꼭 표기할게요!)

괜찮으시다면 ‘좋아요’나 짧게 '답글' 남겨주시면 정말 감사드리겠습니다🙇‍♀️

오늘도 기분 좋은 하루 보내세요💛`

    copyToClipboard(comment);
    window.open(url, '_blank');

    if(status=='승인 필요')
      handleResourceStatusChange(authorName, '승인 대기')
  };

  async function syncDeniedAuthors() {
    try {
      const reviews = stepProps[4]?.blogReviews || [];
      const ids = [...new Set(
        reviews.map(r => r?.authorId).filter(Boolean).map(String)
      )];
      if (ids.length === 0) return;

      const { data } = await api.get('/advise/admin/resource/denied-authors', {
        params: { author_ids: ids.join(',') }
      });

      const deniedIdSet = new Set((data?.denied || []).map(String));

      // 거절된 저자의 "표시용 이름" 목록 만들기
      const deniedNames = [...new Set(
        reviews
          .filter(r => r?.authorId && deniedIdSet.has(String(r.authorId)))
          .map(r => r.authorName)
      )];

      if (deniedNames.length === 0) return;

      // resourceStatus에 병합: denied로 들어간 저자는 다른 버킷에서 제거
      setStepProps(prev => {
        const next = [...prev];
        const rs = next[10]?.resourceStatus || { before:[], pending:[], approve:[], denied:[] };
        const deniedSet = new Set([...(rs.denied || []), ...deniedNames]);

        next[10] = {
          ...next[10],
          resourceStatus: {
            before: (rs.before || []).filter(n => !deniedSet.has(n)),
            pending: (rs.pending|| []).filter(n => !deniedSet.has(n)),
            approve: (rs.approve|| []).filter(n => !deniedSet.has(n)),
            denied:  Array.from(deniedSet),
          }
        };
        return next;
      });
    } catch (err) {
      console.error('syncDeniedAuthors error:', err);
    }
  }

  const saveFiles = async () => {
    if(stepProps[8].fileName.length==0)
      return;
    
    setIsSaving(true);
    const infoRes = await api.get('/advise/admin/fileInfo', {
      params: { name: stepProps[8].fileName }
    });
    const matches = infoRes.data || [];
    const exact = matches.find(item => item.name === stepProps[8].fileName);

    if (exact) {
      // 이미 업로드 완료된 경우
      if (exact.is_uploaded) {
        window.alert(`이미 ${exact.region} 계정에 업로드된 프로젝트입니다.\n다른 파일명을 입력해주세요.`);
        setIsSaving(false);
        return;
      }
      // 존재만 하고 업로드되지 않았다면 덮어쓰기 확인
      const ok = window.confirm("이미 존재하는 파일명입니다.\n기존 파일을 덮어쓰시겠습니까?");
      if (!ok) {
        setIsSaving(false);
        return;
      }
    }

    const selectedCursors = new Set(
      (stepProps[6].selectedImages || []).map(([blogCursor, _]) => blogCursor)
    );

    // 2) 그 cursor 들에 해당하는 blogReviews 만 필터링해서 매핑
    const allAuthorInfoList = stepProps[4].blogReviews
      .map((review, idx) => ({ review, idx }))
      .filter(({ idx }) => selectedCursors.has(idx))
      .map(({ review }) => ({
        url:        review.url ?? null,
        authorName: review.authorName,
        authorId:   review.authorId
      }));

    // 2) 필요한 authorIdList 계산 (기존 로직)
    const authorIdList = Array.from(
      new Set(
        stepProps[8].pages.flatMap(page =>
          page.captions
            .filter(cap => cap.type === 'createBy')
            .map(cap  => cap.text)
        )
      )
    );

    // 3) allAuthorInfoList에서 authorIdList에 포함된 것만 골라냄
    const usedAuthorInfoList = allAuthorInfoList.filter(info =>
      authorIdList.includes(info.authorId)
    );

    try {
        const response = await api.post(
          `/advise/admin/save-file`,
          {
            name: stepProps[8].fileName,
            region: stepProps[1],
            hotple_id: stepProps[2]=='manual' ? null : (stepProps[3].hotple ? stepProps[3].hotple.hotple_id : null),
            naver_map_place_id : stepProps[2]=='manual' ? null : (stepProps[3].hotple ? stepProps[3].hotple.naver_map_place_id : null),
            updated_device: isBrowser?'PC':(isIOS?'IOS':'ANDROID'),
            pages: JSON.stringify(stepProps[8].pages),
            contents: stepProps[8].result,
            video_preview: stepProps[8].video_preview,
            all_resource: allAuthorInfoList,
            used_resource: usedAuthorInfoList,
            addLastPromotionPage: stepProps[8].addLastPromotionPage,
            props: JSON.stringify(
              stepProps.map((item, idx) => {
                if (idx === 0) {
                  return {};
                }
                else if (idx === 3) {
                  return {...item, hotples: []};
                }
                else if (idx === 6) {
                  return {...item, blogImages: [], blogCursor: 0, officialImages:[], gifImages:{} };
                }
                else if (idx === 7) {
                    return {...item, originalImages: []};
                }
                else if (idx === 8) {
                  return {
                    ...item,
                    result: [],
                    video_preview: [],
                    oriFileName: stepProps[8].fileName,
                    file: null,
                    pages: []
                  };
                }
                return item;
              })
            )
          }
        );

        setStepProps(prev => {
            const newProps = [...prev];
            newProps[8] = {
                ...newProps[8],
                oriFileName: stepProps[8].fileName
            };
            newProps[10] = {
                ...newProps[10],
                adviseId: response.data.adviseId
            };
            return newProps;
        });

        loadResources();
        setShowSaveModal(false);
        setShowResourceModal(true);
    } catch (error) {
      console.error('Error saveFiles:', error);
    } finally{
      setIsSaving(false);
    }
  }

  // 처음 마운트 시, 0번 페이지부터 로드
  useEffect(() => {
    whenNameChanged(stepProps[8].fileName || stepProps[8].oriFileName || (stepProps[3].hotple ? `${stepProps[1]}_${stepProps[3].hotple.name}` : `${stepProps[1]}_파일명`));
    syncDeniedAuthors();

    if (stepProps[3].hotple.naver_map_place_id !== stepProps[6].placeId) {
      setStepProps(prev => {
        const next = [...prev];
        next[6] = { ...next[6], blogImages: [], selectedImages: [], blogCursor: 0 };
        return next;
      });
      loadBlogImages(0);
    } else if (stepProps[6].blogCursor < Math.min(stepProps[4].blogImageUrls.length, stepProps[4].blogReviews.length)) {
      loadBlogImages(stepProps[6].blogCursor);
    }
    return () => controllerRef.current?.abort();
  }, []);

  // 추가 로드 트리거
  useEffect(() => {
    syncDeniedAuthors();
    if (isFirstLoadRef.current) {
      isFirstLoadRef.current = false;
      return;
    }
    if (stepProps[6].blogCursor < Math.min(stepProps[4].blogImageUrls.length, stepProps[4].blogReviews.length)) {
      loadBlogImages(stepProps[6].blogCursor);
    }
  }, [stepProps[6].blogCursor]);

  useEffect(() => {
    setStepProps(prev => {
      const next = [...prev];
      next[6] = { ...next[6],
        authorIds: extractOfficialImageUrls(stepProps[4].place).filter((url, idx) => stepProps[6].selectedOfficialImages?.includes(idx)).map(() => '업체등록사진')
          .concat(
            stepProps[6].selectedImages.filter(([b,i]) => stepProps[10]?.resourceStatus?.approve?.includes(stepProps[4].blogReviews[b].authorName))
            ?.map(([b, i]) => stepProps[4].blogReviews[b].authorId)
          )
      };
      return next;
    });
  }, [stepProps[6].selectedOfficialImages, stepProps[6].selectedImages, stepProps[10].resourceStatus]);

  useEffect(() => {
    // 1) null URL 제거
    const entries = gifEntries.filter(e => e.url);
    if (entries.length === 0) return;

    // 2) URL 리스트 한 번에 API 호출
    const urls = entries.map(e => e.url);
    axios.post('https://hotple.today/win-api/api/blog-image', {
      image_urls: urls,
      need_compress: true
    }).then(res => {
      const images = Array.isArray(res.data.images)
        ? res.data.images
        : [];

      // 3) 응답 순서대로 gifImages 맵에 저장
      const newMap = {};
      entries.forEach(({ blogCursor, imageIndex }, i) => {
        const key = `${blogCursor}-${imageIndex}`;
        newMap[key] = images[i] || null;
      });
      setStepProps(prev => {
        const next = [...prev];
        next[6] = { ...next[6], gifImages: {...next[6].gifImages, ...newMap}};
        return next;
      });
    }).catch(err => {
      console.error('GIF 일괄 로드 실패:', err);
    });
  }, [gifEntries]);

  useEffect(() => {
    if (!stepProps[8].fileName) {
      setFileInfoList([]);
      setIsDuplicate(false);
      return;
    }

    // 입력이 멈추고 100ms 뒤에 한 번만 호출
    const handler = setTimeout(async () => {
      try {
        const res = await api.get('/advise/admin/fileInfo', {
          params: { name: stepProps[8].fileName }
        });

        // API가 배열로 반환한다고 가정
        setFileInfoList(res.data);
        // 정확히 동일한 이름이 있는지 체크
        setIsDuplicate(
          res.data.some(item => item.name === stepProps[8].fileName)
        );
      } catch (err) {
        // 404로 내려오면 그냥 빈 리스트
        if (err.response && err.response.status === 404) {
          setFileInfoList([]);
          setIsDuplicate(false);
        } else {
          console.error('Advise fileInfo fetch error:', err);
        }
      }
    }, 200);

    return () => clearTimeout(handler);
  }, [stepProps[8].fileName]);

  // ─── 렌더 ─────────────────────────────────────────────────────
  return (
    <div className={styles.outerframe}>
      {/* 상단 바 */}
      <div className={styles.upperframe}>
        <img
          className={styles.backbuttonIcon}
          alt=""
          src="images/back_android.svg"
          onClick={() => setAdViseStep(5)}
        />
        <div className={styles.titleframe}>
          <b className={styles.stepTitle}>STEP 6</b>
          <div className={styles.stepdesc}>매력적인 이미지들을 모두 선택!</div>
        </div>
        <img
          className={styles.homebuttonIcon}
          alt=""
          src="images/home_outlined.svg"
          onClick={whenHomeButtonClicked}
        />
      </div>

      {/* 이미지 리스트 */}
      <div
        className={styles.lowerframe}
        style={{ height: `calc(100dvh - ${marginTop}px - 103px - 74px)` }}
        ref={lowerFrameRef}
      >
        <div className={styles.contentframe}>
          {!isGifMode &&
            <div className={styles.stepTitle3}>
              {/* 전체 버튼 */}
              <label className={styles.label1}>
                <input
                  type="radio"
                  name="filter"
                  className={styles.radio}
                  checked={filterCursor1 === null}
                  onChange={()=> setFilterCursor1(null)}
                />
                전체<br/>({selectedLength}|{stepProps[4].blogImageUrls.flat().length})
              </label>
              <label className={styles.label1} style={{color:'#007aec'}}>
                <input
                  type="radio"
                  name="filter"
                  className={styles.radio}
                  checked={filterCursor1 === '공식'}
                  onChange={()=> setFilterCursor1('공식')}
                />
                업체등록사진<br/>({(stepProps[6].selectedOfficialImages||[]).length}|{extractOfficialImageUrls(stepProps[4].place).length})
              </label>
              {/* 블로그별 버튼 */}
              {(() => {
                const blogUrls = stepProps[4]?.blogImageUrls || [];
                const selected = stepProps[6]?.selectedImages || [];
                const approvedAuthors = stepProps[10]?.resourceStatus?.approve || [];
                const deniedAuthors   = stepProps[10]?.resourceStatus?.denied  || [];

                return Array.from({ length: blogUrls.length }, (_v, b) => {
                  const author = stepProps[4]?.blogReviews?.[b]?.authorName || 'Unknown';
                  // 이 블로그에서 선택된 이미지 수
                  const selectedCount = selected.filter(([bb]) => bb === b).length;
                  // 이 블로그의 전체 이미지 수
                  const totalCount = blogUrls[b]?.length || 0;
                  // 승인 상태에 따라 색상
                  const color = deniedAuthors.includes(author)
                    ? '#afafafff'               // 거절은 빨강
                    : approvedAuthors.includes(author)
                      ? '#007aec'             // 승인완료는 파랑
                      : selectedCount > 0
                        ? '#ff0069'           // 선택됨 강조
                        : '#1c1c1c';          // 기본

                  return (
                    <label key={b} className={styles.label1}>
                      <input
                        type="radio"
                        name="filter"
                        className={styles.radio}
                        value={b}
                        checked={filterCursor1 === b}
                        onChange={() => setFilterCursor1(b)}
                      />
                      <span
                        onClick={() => window.open(stepProps[4].blogReviews[b]?.url, '_blank')}
                        style={{ cursor: 'pointer', color, textDecoration: `${deniedAuthors.includes(author)?'line-through':'none'}` }}
                      >
                        {author}<br/>({selectedCount}|{totalCount})
                      </span>
                    </label>
                  );
                });
              })()}
            </div>
          }

          {!isGifMode && (filterCursor1 == null || filterCursor1 == '공식') &&
            stepProps[6].officialImages.map((image, idx) => {
              return (
                <div
                  key={`official-${idx}`}
                  className={styles.imageframe}
                  onClick={() => {if(!image || image=='broken') return; whenOfficialImageClicked(idx);}}
                >
                  {image != undefined 
                      ?
                        image != 'broken'
                        ?
                          <img
                            className={styles.imageIcon}
                            alt=""
                            src={`data:image/jpeg;base64,${image}`}
                          />
                        :
                          <div className={styles.loadingFrame}>
                            <div className={styles.official}>깨진 이미지</div>
                          </div>
                      :
                        <div className={styles.loader} />
                  }
                  <div className={styles.sourceFrame}>
                    <img className={styles.iconcheckedFilled2} alt="" src="images/naver.svg" />
                    <div className={styles.sourceTextFrame}>
                      <div className={styles.sourceText}>
                        업체등록사진
                      </div>
                    </div>
                  </div>
                  {stepProps[6].selectedOfficialImages?.includes(idx) && (
                    <>
                      <div className={styles.screen} />
                      <img
                        className={styles.iconcheckedFilled}
                        alt=""
                        src="images/checked_filled.svg"
                      />
                    </>
                  )}
                </div>
              )
            })
          }

          {!isGifMode && (filterCursor1 == null || filterCursor1 == '공식') && isOfficialLoading &&
            <div className={styles.imageframe}>
              <div className={styles.loadingFrame}>
                <div className={styles.loader} />
                <div className={styles.official}>업체등록사진 로드 중...</div>
                <div className={styles.official}>{extractOfficialImageUrls(stepProps[4].place).length}장</div>
              </div>  
            </div>
          }
          
          {(() => {
            // 보여줄 아이템 추리기
            let items;
            if (!isGifMode) {
              items = (stepProps[6].blogImages || []).flatMap((imagesArr, blogCursor) => {
                // filterCursor1 이 지정돼 있으면, 그 blogCursor 만 내보내고
                if (filterCursor1 != null && filterCursor1 !== blogCursor) {
                  return [];
                }
                // 아니면 해당 blogCursor 의 모든 이미지 엔트리를
                return imagesArr.map((img, imageIndex) => ({
                  image: img,
                  blogCursor,
                  imageIndex
                }));
              });
            } else {
              items = gifEntries.map(({ blogCursor, imageIndex }) => {
                const key = `${blogCursor}-${imageIndex}`;
                return {
                  image: stepProps[6].gifImages[key] ?? null,
                  blogCursor,
                  imageIndex,
                  isGifLoading: !stepProps[6].gifImages[key]
                }
              })
            }

            return items.map(({ image, blogCursor, imageIndex, isGifLoading }) => {
              const isSelected = (stepProps[6].selectedImages || [])
                .some(([b, i]) => b === blogCursor && i === imageIndex);

              return (
                <div
                  key={`${blogCursor}-${imageIndex}`}
                  className={styles.imageframe}
                  onClick={() => {if(isGifLoading || !image || image=='broken') return; whenImageClicked(blogCursor, imageIndex);}}
                >
                  {isGifMode && isGifLoading
                    ?
                      <div className={styles.loader} />    // GIF 로딩 중 스켈레톤
                    :
                      image != undefined 
                      ?
                        image != 'broken'
                        ?
                          <img
                            className={styles.imageIcon}
                            alt=""
                            src={`data:image/jpeg;base64,${image}`}
                          />
                        :
                          <div className={styles.loadingFrame}>
                            <div className={styles.official}>깨진 이미지</div>
                          </div>
                      :
                        <div className={styles.loader} />
                  }
                  <div
                    className={styles.sourceFrame}
                    onClick={e => { e.stopPropagation(); whenSourceClicked(stepProps[4].blogReviews[blogCursor].url); }}
                  >
                    <img className={styles.iconcheckedFilled2} alt="" src="images/naver.svg" />
                    <div className={styles.sourceTextFrame}>
                      <div className={styles.sourceText}>
                        {stepProps[4].blogReviews[blogCursor]?.authorName} (
                        {stepProps[4].blogReviews[blogCursor]?.date})
                      </div>
                      <div className={styles.sourceText}>
                        {stepProps[4].blogReviews[blogCursor]?.title}
                      </div>
                    </div>
                  </div>
                  {isSelected && (
                    <>
                      <div className={styles.screen} />
                      <img
                        className={styles.iconcheckedFilled}
                        alt=""
                        src="images/checked_filled.svg"
                      />
                    </>
                  )}
                </div>
              );
            });
          })()}

          {/* “전체” 탭에서만 추가 로드 버튼 */}
          {!isGifMode && stepProps[6].blogCursor < stepProps[4].blogReviews.length && filterCursor1==null && (
            <div
              className={styles.imageframe}
              onClick={() => !isLoading && loadBlogImages(stepProps[6].blogCursor)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
              }}
            >
              {isLoading ? (
                <>
                  <div className={styles.loader} />
                  <div className={styles.official}>블로그 사진 로드 중...</div>
                  <div className={styles.official}>{stepProps[4].blogImageUrls.length-1 >= stepProps[6].blogCursor ? stepProps[4].blogImageUrls[stepProps[6].blogCursor].length : '-'}장</div>
                </>
              ) : (
                <div style={{ textAlign: 'center', color: '#fff' }}>
                  <div style={{ fontSize: 20, fontWeight: 'bold' }}>이미지 추가 로드</div>
                  <div style={{ marginTop: 4, fontSize: 16 }}>
                    ({stepProps[6].blogCursor} / {stepProps[4].blogReviews.length})
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        <img
          className={styles.topButton}
          alt="맨 위로"
          src="images/chevron_bottom.svg"
          onClick={whenTopButtonClicked}
        />

        <div
          className={styles.topButton2}
          onClick={()=>setIsGifMode(state=> {return !state})}
        >
          {isGifMode ? 'ALL': 'GIF'}
        </div>
      </div>

      {/* 하단 버튼들 */}
      <div className={styles.nextbuttonframe}>
        <div className={styles.resetButton} onClick={whenResetButtonClicked}>
          <b className={styles.nextbuttontext}>초기화</b>
        </div>
        <div
          className={selectedLength > 0
            ? styles.nextbutton2
            : styles.nextbuttonDisabled2}
          onClick={() =>selectedLength > 0 && setShowSelectedOverlay(true)}
        >
          <b className={styles.nextbuttontext}>
            {selectedLength}개 선택됨
          </b>
        </div>
        <div className={selectedLength >= 9 ? styles.nextbutton : styles.nextbuttonDisabled} onClick={() => whenSaveButtonClicked()}>
          <b className={styles.nextbuttontext}>{selectedLength >= 9 ? `임시 저장 (가용 이미지 ${selectedAvailableUrls.length}장)` : '9개 이상 선택'}</b>
        </div>
      </div>

      {showSelectedOverlay && (
        <div className={styles.selectedOverlay} onClick={() => setShowSelectedOverlay(false)}>
          <div className={styles.thumbnailFrame} onClick={e => e.stopPropagation()}>

            {/* ★ 라디오 버튼 추가 ★ */}
            <div className={styles.stepTitle3}>
              {/* 전체 버튼 */}
              <label className={styles.label1}>
                <input
                  type="radio"
                  name="filter"
                  className={styles.radio}
                  checked={filterCursor2 === null}
                  onChange={()=> setFilterCursor2(null)}
                />
                전체({selectedLength})
              </label>
              <label className={styles.label1}>
                <input
                  type="radio"
                  name="filter"
                  className={styles.radio}
                  checked={filterCursor2 === '공식'}
                  onChange={()=> setFilterCursor2('공식')}
                />
                업체등록사진({(stepProps[6].selectedOfficialImages||[]).length})
              </label>
              {/* 블로그별 버튼 */}
              {(() => {
                const counts = {};
                (stepProps[6].selectedImages||[]).forEach(([b])=>{
                  counts[b] = (counts[b]||0) + 1;
                });
                return Object.entries(counts).map(([b, cnt]) => (
                  <label key={b} className={styles.label1}>
                    <input
                      type="radio"
                      name="filter"
                      className={styles.radio}
                      value={b}
                      checked={filterCursor2 === Number(b)}
                      onChange={() => setFilterCursor2(Number(b))}
                    />
                    <span
                      onClick={()=>
                        window.open(stepProps[4].blogReviews[b].url, '_blank')
                      }
                      style={{cursor:'pointer', color:(stepProps[10]?.resourceStatus.approve || []).includes(stepProps[4].blogReviews[b].authorName) ? '#007aec' : '#ff0069'}}
                    >
                      {stepProps[4].blogReviews[b].authorName}({cnt})
                    </span>
                  </label>
                ));
              })()}
            </div>
            {/* ★ 여기까지 ★ */}

            <div className={styles.selectedImagesContainer}>
              {(filterCursor2 =='공식' || filterCursor2 == null) &&
                // 3) filterCursor에 따라 보여줄 것 걸러주기
                stepProps[6].selectedOfficialImages
                ?.map((image_idx, idx) => {
                  const base64 = stepProps[6].officialImages[image_idx];
                  return (
                    <div key={idx} className={styles.selectedImageFrame}>
                      <img
                        className={styles.selectedImage}
                        src={`data:image/jpeg;base64,${base64}`}
                        alt=""
                        onClick={()=> whenOfficialImageClicked(image_idx)}
                      />
                    </div>
                  );
                })
              }
              {(stepProps[6].selectedImages||[])
                // 3) filterCursor에 따라 보여줄 것 걸러주기
                .filter(([b]) => filterCursor2 === null || filterCursor2 === b)
                .map(([blogCursor, imageIndex], idx) => {
                  const key = `${blogCursor}-${imageIndex}`;
                  const base64 =
                    stepProps[6].blogImages?.[blogCursor]?.[imageIndex]
                    ?? stepProps[6].gifImages[key];
                  return (
                    <div key={idx} className={styles.selectedImageFrame}>
                      <img
                        className={styles.selectedImage}
                        src={`data:image/jpeg;base64,${base64}`}
                        alt=""
                        onClick={()=> whenImageClicked(blogCursor, imageIndex)}
                      />
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      )}

      {showSaveModal && (
        <div className={styles.selectedOverlay} onClick={() => setShowSaveModal(false)}>
          {isSaving &&
            <div className={styles.loadingFrame}>
              <div className={styles.loader} />
              <div className={styles.loadingText}>파일 저장 중...</div>
            </div>
          }
          <div className={styles.saveFrame} onClick={e => e.stopPropagation()}>
            <div className={styles.stepTitle2}>파일 저장</div>
            
            <div className={styles.nameframe}>
              <div className={styles.div0}>파일명 :</div>
              <div className={styles.nameinput}>
                <img className={styles.iconpen} alt="" src="images/pen.svg" />
                <input
                      type="text"
                      id="nameInput1"
                      list="fileNameList"
                      className={isDuplicate ? styles.nameInput0 : styles.nameInput1}
                      value={stepProps[8].fileName}
                      onChange={(e) => whenNameChanged(e.target.value)}
                      placeholder={stepProps[8].oriFileName || (stepProps[3].hotple ? `${stepProps[1]}_${stepProps[3].hotple.name}` : `${stepProps[1]}_파일명`)}
                      autoComplete="off"
                      onKeyDown={(e) => {if (e.key === 'Enter') {e.target.blur();}}}
                />
                <datalist id="fileNameList">
                  {fileInfoList.map(item => (
                    <option key={item.id} value={item.name} />
                  ))}
                </datalist>
              </div>
            </div>

            <div className={styles.footer}>
              <div className={styles.backbutton2} onClick={()=>setShowSaveModal(false)}>
                  <div className={styles.nextbuttontext2}>취소</div>
              </div>
              <div className={!stepProps[8].fileName || stepProps[8].fileName.trim().length === 0 ? styles.nextbuttonDisabled : styles.nextbutton} onClick={saveFiles}>
                  <b className={styles.nextbuttontext}>{isDuplicate ? "기존 파일 덮어쓰기 →":"저장하기 →"}</b>
              </div>
            </div>
          </div>
        </div>
      )}

      {showResourceModal && (
        <div className={styles.selectedOverlay} onClick={() => setShowResourceModal(false)}>
          <div className={styles.resourceFrame} onClick={e => e.stopPropagation()}>
            <div className={styles.stepTitle2}>리소스 요청</div>

            {resources.length > 0 && (
              <div className={styles.resourcesFrame}>
                <div className={styles.resourcesTitle}>리소스<br/>상태</div>
                {[...resources]
                  // used_resource에 포함된 순서대로 앞으로
                  .sort((a, b) => {
                    const aUsed = usedResource.includes(a.id);
                    const bUsed = usedResource.includes(b.id);
                    if (aUsed === bUsed) return 0;
                    return aUsed ? -1 : 1;
                  })
                  .map(res => {
                    const statusClass = (() => {
                      switch (res.status) {
                        case '승인 필요': return styles.needs;
                        case '승인 대기': return styles.pending;
                        case '승인 완료': return styles.approved;
                        case '승인 거절': return styles.deny;
                        default: return '';
                      }
                    })();
                    const isUsed = usedResource.includes(res.id);
                    return (
                      <div
                        key={res.id}
                        className={isUsed ? styles.resourceRowUsed : styles.resourceRow}
                      >
                        <div
                          onClick={() => whenBlogClicked(res.status, res.url, res.author_name)}
                          className={`${styles.resourceLink} ${statusClass}`}
                        >
                          {res.author_name}
                        </div>
                        <select
                          className={`${styles.ratioSelect} ${statusClass}`}
                          value={res.status}
                          onChange={e => handleResourceStatusChange(res.author_name, e.target.value)}
                        >
                          <option value="승인 필요">승인 필요</option>
                          <option value="승인 대기">승인 대기</option>
                          <option value="승인 완료">승인 완료</option>
                          <option value="승인 거절">승인 거절</option>
                        </select>
                      </div>
                    );
                  })}
              </div>
            )}

            <div className={styles.footer}>
              <div className={styles.backbutton2} onClick={()=>setShowResourceModal(false)}>
                  <div className={styles.nextbuttontext2}>취소</div>
              </div>
              <div className={selectedAvailableUrls.length < 9 ? styles.nextbuttonDisabled : styles.nextbutton}
                onClick={()=>{if(selectedAvailableUrls.length < 9) return; setSelectedThumbnail(null); setSelectedPriority([]); setShowResourceModal(false); setShowThumbnailModal(true);}}>
                  <b className={styles.nextbuttontext}>{selectedAvailableUrls.length < 9 ? `가용 이미지 부족` : '썸네일 설정'} ({selectedAvailableUrls.length}장)</b>
              </div>
            </div>
          </div>
        </div>
      )}

      {showThumbnailModal && (
        <div className={styles.selectedOverlay} onClick={() => setShowThumbnailModal(false)}>
          <div className={styles.thumbnailFrame} onClick={e => e.stopPropagation()}>
            <div className={styles.stepTitle2}>썸네일로 쓸 이미지 선택!</div>
            <div className={styles.selectedImagesContainer2}>
              {(selectedAvailableImages || []).map((base64, idx) => {
                const isSel = selectedThumbnail === idx;
                return (
                  <div
                    key={idx}
                    className={styles.selectedImageFrame}
                    onClick={() => setSelectedThumbnail(idx)}
                  >
                    <img
                      className={styles.selectedImage}
                      src={`data:image/jpeg;base64,${base64}`}
                      alt=""
                    />
                    {isSel && (
                      <>
                        <div className={styles.screen} />
                        <img
                          className={styles.iconcheckedFilled}
                          src="images/checked_filled.svg"
                          alt=""
                        />
                      </>
                    )}
                  </div>
                );
              })}
              <div style={{ clear: 'both' }} />
            </div>
            <div className={styles.footer}>
              <div className={styles.backbutton2} onClick={()=>setShowThumbnailModal(false)}>
                  <div className={styles.nextbuttontext2}>취소</div>
              </div>
              <div className={selectedThumbnail !== null ? styles.nextbutton : styles.nextbuttonDisabled}
                onClick={() => {
                  if (selectedThumbnail === null) return;
                  // selectedThumbnail 이 이제 배열 index
                  setStepProps(prev => {
                    const next = [...prev];
                    next[6] = { ...next[6], thumbnailIndex: selectedThumbnail };
                    return next;
                  });
                  setShowThumbnailModal(false);
                  setShowPriorityModal(true);
                }}
              >
                  <b className={styles.nextbuttontext}>계속할래요 →</b>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPriorityModal && (
        <div className={styles.selectedOverlay} onClick={()=>setShowPriorityModal(false)}>
          <div className={styles.thumbnailFrame} onClick={e=>e.stopPropagation()}>
            <div className={styles.stepTitle2}>2~8 번째 이미지 선택</div>
            <div className={styles.selectedImagesContainer2}>
              {selectedAvailableImages
              .map((base64, idx) => ({ base64, idx }))
              .filter(item => item.idx !== selectedThumbnail)      // ★ 썸네일 인덱스 제외
              .map(({ base64, idx }) => {
                const isSel = selectedPriority.includes(idx);
                return (
                  <div
                    key={idx}
                    className={styles.selectedImageFrame}
                    onClick={() => {
                      setSelectedPriority(prev => {
                        if (prev.includes(idx)) {
                          return prev.filter(i => i !== idx);
                        } else if (prev.length < 8) {
                          return [...prev, idx];
                        }
                        return prev;
                      });
                    }}
                  >
                    <img className={styles.selectedImage} src={`data:image/jpeg;base64,${base64}`} alt="" />
                    {isSel && (
                      <>
                        <div className={styles.screen} />
                        <span className={styles.iconcheckedFilled3}>
                          {selectedPriority.indexOf(idx) + 1}
                        </span>
                      </>
                    )}
                  </div>
                );
              })}
              <div style={{ clear: 'both' }}/>
            </div>
            <div className={styles.footer}>
              <div className={styles.backbutton2} onClick={()=>setShowPriorityModal(false)}>
                <div className={styles.nextbuttontext2}>취소</div>
              </div>
              <div
                className={selectedPriority.length === 8 ? styles.nextbutton : styles.nextbuttonDisabled}
                onClick={() => {
                  if (selectedPriority.length !== 8) return;
                  // 우선순위 인덱스 저장
                  setStepProps(prev => {
                    const next = [...prev];
                    next[6] = { ...next[6], priorityIndex: selectedPriority };
                    return next;
                  });
                  setShowPriorityModal(false);
                  // 기존 다음 단계 로직 그대로 호출
                  whenNextButtonClicked();
                }}
              >
                <b className={styles.nextbuttontext}>계속할래요 →</b>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* 로딩 중 */}
      {isPatching && (
        <div className={styles.loadingFrame}>
          <div className={styles.loader} />
          <div className={styles.loadingText}>고화질 이미지 다운로드 중...</div>
        </div>
      )}
    </div>
  );
};

export default AdViseStep6;
